module.exports = __webpack_public_path__ + "img/avatar.a45f0056.png";